export default "__VITE_ASSET__Bw$c5As2__"